/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employee_absences_EmployeeBrief } from './employee_absences_EmployeeBrief';
export type employee_absences_AbsenceResponse = {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    absence_type?: string;
    /**
     * Self-reported ACCIDENT only: day of the accident (YYYY-MM-DD)
     */
    accident_date?: string;
    /**
     * When the office acknowledged the report
     */
    acknowledged_at?: string;
    /**
     * User ID of the office user who acknowledged the report
     */
    acknowledged_by?: string;
    /**
     * Approval status: REQUESTED, APPROVED, REJECTED, or CANCELLED
     */
    approval_status?: string;
    /**
     * Timestamp when the absence was approved or rejected
     */
    approved_at?: string;
    /**
     * User ID who approved or rejected the absence
     */
    approved_by?: string;
    /**
     * Reason the office gave when it cancelled the report
     */
    cancel_reason?: string;
    /**
     * Doctor's certificate state: NOT_DUE, DUE, PROVIDED, EAU_RETRIEVED, or NOT_REQUIRED
     */
    certificate_status: employee_absences_AbsenceResponse.certificate_status;
    /**
     * Timestamp when the absence was created (RFC3339 format, UTC)
     */
    created_at?: string;
    /**
     * EAU mode: when the office retrieved the electronic certificate
     */
    eau_retrieved_at?: string;
    /**
     * EAU mode: user ID of the office user who retrieved the electronic certificate
     */
    eau_retrieved_by?: string;
    /**
     * Employee details (included when fetching absence)
     */
    employee?: employee_absences_EmployeeBrief;
    /**
     * ID of the employee
     */
    employee_id?: string;
    /**
     * The employee went home at this time on the first day (HH:MM); shifts on that day were kept
     */
    first_day_from_time?: string;
    /**
     * Start date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    from_date?: string;
    /**
     * Start time for partial-day absences in HH:MM format
     */
    from_time?: string;
    /**
     * Whether this is a full-day absence
     */
    full_day?: boolean;
    /**
     * Unique identifier for the absence
     */
    id?: string;
    /**
     * Whether this absence was individually modified from a pattern
     */
    is_exception?: boolean;
    /**
     * true when the employee reported the absence (SICK, ACCIDENT, CHILD_SICK); it took effect at once
     */
    is_self_report: boolean;
    /**
     * Optional notes about the absence
     */
    notes?: string;
    /**
     * true when the report overlaps a vacation absence that the office should correct
     */
    overlaps_vacation: boolean;
    /**
     * Reference to the absence pattern for recurring absences
     */
    pattern_id?: string;
    /**
     * Reason for rejection
     */
    rejection_reason?: string;
    /**
     * End date of the absence in ISO 8601 format (YYYY-MM-DD)
     */
    to_date?: string;
    /**
     * End time for partial-day absences in HH:MM format
     */
    to_time?: string;
    /**
     * Timestamp when the absence was last updated (RFC3339 format, UTC)
     */
    updated_at?: string;
    /**
     * Self-reported ACCIDENT only: the accident happened at work or on the way to work
     */
    work_related?: boolean;
};
export namespace employee_absences_AbsenceResponse {
    /**
     * Doctor's certificate state: NOT_DUE, DUE, PROVIDED, EAU_RETRIEVED, or NOT_REQUIRED
     */
    export enum certificate_status {
        NOT_DUE = 'NOT_DUE',
        DUE = 'DUE',
        PROVIDED = 'PROVIDED',
        EAU_RETRIEVED = 'EAU_RETRIEVED',
        NOT_REQUIRED = 'NOT_REQUIRED',
    }
}

